import { TimeStamp } from "ts/models/timestamp";

export const PlotPlanType = {
  OVERVIEW: 1,
  DETAIL: 2,
} as const;
export type PlotPlanTypeType = (typeof PlotPlanType)[keyof typeof PlotPlanType];

export type PlotPlan = {
  plot_plan_id: number;
  plot_plan_type: PlotPlanTypeType;
  quality: number;
  plot_plan_name: string;
  note: string;
  map_image_id: number;
  file_size: number;
  timestamp: TimeStamp;
};

export type PlotPlanDetail = {
  plot_plan_id: number;
  plot_plan_type: PlotPlanTypeType;
  construction_id: number;
  quality: number;
  plot_plan_name: string;
  note: string;
  file_name: string;
  timestamp: TimeStamp;
};
